// Rapports journaliers saisis sans réseau : gardés sur l'appareil (localStorage), envoyés automatiquement dès que la
// connexion revient (événement « online », au démarrage, puis toutes les minutes). Un rapport refusé par le serveur
// (date déjà saisie, numéro de poteau pris…) reste en attente avec le message d'erreur, pour être corrigé ou supprimé.
import api from '../services/api';

const CLE = 'docc_rapports_en_attente';
const EVT = 'docc-file-attente';

export function lireFile() {
  try { const l = JSON.parse(localStorage.getItem(CLE) || '[]'); return Array.isArray(l) ? l : []; } catch { return []; }
}
function ecrire(l) {
  try { localStorage.setItem(CLE, JSON.stringify(l)); } catch { /* stockage plein ou indisponible */ }
  window.dispatchEvent(new Event(EVT));
}
export function ajouterRapport(payload) {
  let user = null;
  try { user = JSON.parse(localStorage.getItem('user') || 'null'); } catch { /* ignoré */ }
  const l = lireFile();
  l.push({ id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`, payload, cree_le: new Date().toISOString(), user_id: user?.id || null, erreur: null });
  ecrire(l);
}
export function supprimerRapport(id) { ecrire(lireFile().filter((r) => r.id !== id)); }
export const rapportEnAttentePour = (date) => lireFile().some((r) => r.payload?.report_date === date);
export function onFileChange(fn) {
  window.addEventListener(EVT, fn);
  window.addEventListener('storage', fn);
  return () => { window.removeEventListener(EVT, fn); window.removeEventListener('storage', fn); };
}

let enCours = false;
/** Envoie les rapports en attente. Renvoie { envoyes, restants, erreurs }. */
export async function envoyerFile() {
  if (enCours) return null;
  if (!localStorage.getItem('token')) return null;
  enCours = true;
  let envoyes = 0;
  try {
    for (const r of lireFile()) {
      if (r.erreur) continue; // refusé : attend une correction
      try {
        // eslint-disable-next-line no-await-in-loop
        await api.post('/reports', r.payload);
        supprimerRapport(r.id); envoyes += 1;
      } catch (e) {
        if (!e.response) break; // toujours pas de réseau
        if (e.response.status === 401) break; // session expirée : reconnexion nécessaire
        const l = lireFile();
        const x = l.find((y) => y.id === r.id);
        if (x) { x.erreur = e.response.data?.error || `Refusé par le serveur (${e.response.status})`; ecrire(l); }
      }
    }
  } finally { enCours = false; }
  const l = lireFile();
  return { envoyes, restants: l.length, erreurs: l.filter((r) => r.erreur).length };
}
/** Remet un rapport refusé dans la file (après correction côté serveur, ex. ancien rapport supprimé). */
export function reessayer(id) { const l = lireFile(); const x = l.find((y) => y.id === id); if (x) { x.erreur = null; ecrire(l); } return envoyerFile(); }

let demarre = false;
export function demarrerSynchro() {
  if (demarre) return;
  demarre = true;
  window.addEventListener('online', () => { envoyerFile(); });
  setTimeout(() => { if (navigator.onLine) envoyerFile(); }, 3000);
  setInterval(() => { if (navigator.onLine && lireFile().some((r) => !r.erreur)) envoyerFile(); }, 60000);
}
